/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/pageproperties/questionproperties/questionformat/questionformat_styles';


/* ========== ~~~~~~~~~~ QUESTION FORMAT : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const QuestionFormat = (props) => {

	const handleSelected = () => {
		if (props.selectedType !== props.type) {
			props.setSelectedContentProperty(true, 'type', props.type);
		}
	}

	const phase = props.selectedType === props.type ? 'active' : 'inactive';

	return (
		<div className={`questionformat ${props.classes.questionformat} ${props.type} ${phase}`} onClick={handleSelected}>
			<div className={`visual`} />
			<div className={`desc`}>
				<div className={`icon`} />
				<div className={`text`}>{props.desc}</div>
			</div>
		</div>
	);
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(QuestionFormat);
